import React, { useEffect } from 'react';
import axios from 'axios';

export default function CiaManager() {

  const redirectToCiaManagerUrl = async () => {
    const reqObject = await axios.get(`${import.meta.env.VITE_ROOT_PATH}/api/url/cia-manager`);
    const { data: { url } } = reqObject;
    window.location.replace(url);
  }

  useEffect(() => {
    redirectToCiaManagerUrl();
  }, [])

  return <div></div>
}
